import { matchPath } from 'react-router-dom';

function normalizeKeywords(keywords) {
  return [...new Set(
    keywords
      .map((keyword) => keyword.replace(/,+$/g, '').trim())
      .filter(Boolean)
  )];
}

const defaultSeo = {
  title: 'Middleby Celfrost Innovations Pvt. Ltd.',
  description:
    'Middleby Celfrost distribute global catering equipment brands, such asLincat, Pitco, TurboChef, Sveba dahlen, Firex, Midd=kitchen, Toastmaster, Cooktek, Josper, Bakers Pride and more through a network of Indian distribution partners',
  keywords: normalizeKeywords([
    'Middleby Celfrost',
    'commercial kitchen equipment India',
    'foodservice equipment India',
    'commercial refrigeration India',
    'commercial kitchen equipment distributor India',
    'restaurant equipment supplier India',
    'hotel kitchen equipment supplier',
    'QSR kitchen equipment India',
    'institutional kitchen equipment India',
  ]),
};

const seoRoutes = [
  {
    paths: ['/vero', '/products/brand/vero'],
    title:
      'VERO Coffee Machines | Semi Automatic & Traditional Coffee Machines India',
    description:
      'Explore VERO professional coffee machines for cafes, restaurants, hotels and commercial coffee businesses in India. Discover semi automatic and traditional coffee machine solutions from Middleby Celfrost.',
    keywords: normalizeKeywords([
      'Vero',
      'Caffe Vero',
      'Vero coffee',
      'Vero coffee machine',
      'Vero coffee machines',
      'semi automatic coffee machine',
      'semi automatic coffee machines',
      'traditional coffee machine',
      'traditional coffee machines',
      'best coffee machine',
      'best coffee machines',
      'professional coffee machine',
      'commercial coffee machine',
      'commercial coffee machines India',
      'coffee machine for cafe',
      'coffee machine for restaurant',
      'espresso coffee machine',
      'espresso machine India',
      'cafe coffee machine India',
      'Middleby Vero',
      'Middleby Celfrost Vero',
      'professional espresso machine India',
      'hotel coffee machine India',
      'HoReCa coffee machine supplier',
    ]),
  },
  {
    paths: ['/'],
    title:
      'Commercial Kitchen Equipment Supplier in India | Refrigeration & Cooking Solutions | Middleby Celfrost',
    description:
      'Middleby Celfrost is a leading commercial kitchen equipment supplier in India offering refrigeration, cooking & foodservice solutions for restaurants, hotels & QSRs. Explore high-quality equipment at competitive prices.',
    keywords: normalizeKeywords([
      'commercial kitchen equipment India',
      'industrial kitchen equipment supplier',
      'foodservice equipment India',
      'restaurant kitchen equipment',
      'commercial kitchen equipment supplier near me',
      'buy commercial kitchen equipment India',
      'hotel kitchen equipment',
      'industrial kitchen equipment price',
      'bakery equipment supplier',
      'refrigeration equipment India',
      'professional cooking equipment',
      'best commercial kitchen equipment for restaurants in India',
      'best commercial kitchen brand India',
      'Middleby Celfrost products',
      'bakery equipment supplier in India',
      'commercial food equipment supplier',
      'kitchen solutions India',
      'commercial catering equipment India',
      'commercial kitchen equipment distributor India',
      'hotel kitchen equipment supplier India',
      'QSR kitchen equipment India',
      'cloud kitchen equipment India',
      'cafe equipment supplier India',
      'institutional kitchen equipment India',
      'industrial catering equipment India',
      'energy efficient commercial kitchen equipment',
    ]),
  },
  {
    paths: ['/about-us', '/about-old'],
    title:
      'About Middleby Celfrost | Leading Commercial Kitchen Equipment Supplier in India',
    description:
      'Learn about Middleby Celfrost, a leading commercial kitchen equipment supplier in India. Part of Middleby Corporation USA, delivering premium foodservice & refrigeration solutions through trusted partners.',
    keywords: normalizeKeywords([
      'Middleby Celfrost about us',
      'Middleby Corporation India',
      'commercial kitchen equipment distributors India',
      'global catering equipment brands',
      'Pitco India',
      'TurboChef India',
      'Josper oven India',
      'Lincat India',
      'foodservice equipment suppliers',
      'Indian market kitchen equipment',
      'commercial kitchen equipment company India',
      'kitchen equipment partner India',
      'commercial kitchen equipment brand India',
      'foodservice solutions company India',
      'HoReCa equipment company India',
    ]),
  },
  {
    paths: [
      '/our-products',
      '/products/category/:category',
      '/products/brand/:brand',
      '/products/search/:search',
      '/product-detail/:id',
      '/brand/:brand',
    ],
    title:
      'Commercial Kitchen Equipment Products in India | Buy Restaurant & Bakery Equipment | Middleby Celfrost',
    description:
      'Explore 50+ commercial kitchen equipment products at Middleby Celfrost. Buy pizza ovens, fryers, blast chillers, ice machines & more for restaurants, bakeries & hotels across India.',
    keywords: normalizeKeywords([
      'commercial kitchen equipment products',
      'commercial kitchen equipment India',
      'restaurant kitchen equipment',
      'buy commercial kitchen equipment India',
      'commercial fryer',
      'blast chiller price',
      'ice cube machine',
      'soft serve machine',
      'commercial refrigeration India',
      'deck oven',
      'convection oven',
      'dough mixer',
      'commercial grill',
      'Middleby product range',
      'commercial fryer price India',
      'pizza oven India',
      'restaurant equipment supplier India',
      'bakery equipment India',
      'commercial dishwasher India',
      'commercial coffee machine India',
      'commercial combi oven India',
      'commercial bakery oven India',
      'commercial ice machine India',
      'QSR kitchen equipment supplier India',
      'hotel kitchen equipment India',
    ]),
  },
  {
    paths: ['/contact-us'],
    title: 'Contact Middleby Celfrost | Commercial Kitchen Equipment India',
    description:
      'Contact Middleby Celfrost for commercial kitchen equipment sales, service & support. Get head office details, dealer network & expert assistance in India.',
    keywords: normalizeKeywords([
      'Middleby Celfrost contact',
      'Middleby Celfrost customer care',
      'Middleby Celfrost phone number',
      'Middleby Celfrost email',
      'commercial kitchen equipment dealer contact',
      'restaurant equipment supplier Gurugram',
      'Middleby Celfrost address',
      'foodservice equipment supplier Gurugram',
      'kitchen equipment enquiry India',
      'commercial kitchen support contact',
      'commercial kitchen equipment Gurgaon',
      'commercial kitchen equipment Delhi NCR',
      'commercial kitchen equipment service India',
      'commercial kitchen spare parts India',
    ]),
  },
  {
    paths: ['/culinary'],
    title:
      'Culinary Support & Technical Assistance | Middleby Celfrost India',
    description:
      'Get expert culinary support, technical assistance, chef hotline access, equipment guides & service solutions from Middleby Celfrost India.',
    keywords: normalizeKeywords([
      'Middleby Celfrost culinary support',
      'commercial kitchen equipment guides',
      'recipes for commercial ovens',
      'chef hotline India',
      'commercial kitchen troubleshooting',
      'restaurant equipment application tips',
      'kitchen equipment parts and service',
      'technical support for kitchen equipment',
      'commercial oven support India',
      'commercial kitchen equipment training India',
      'chef equipment demonstration India',
      'commercial kitchen application support',
    ]),
  },
  {
    paths: ['/category/:id', '/blog/:id'],
    title:
      'Commercial Kitchen Equipment Blogs & Industry News | Middleby Celfrost',
    description:
      'Explore blogs, case studies & industry updates on commercial kitchen equipment, ovens, bratt pans & HoReCa solutions by Middleby Celfrost India.',
    keywords: normalizeKeywords([
      'Middleby Celfrost news',
      'commercial kitchen equipment blog',
      'foodservice industry updates India',
      'restaurant equipment case studies',
      'commercial pizza oven blog',
      'commercial kitchen trends',
      'Middleby events',
      'Middleby Celfrost videos',
      'commercial kitchen equipment articles',
      'Middleby Innovation Kitchen',
      'HoReCa insights India',
      'restaurant operations trends',
      'QSR industry trends India',
      'hotel kitchen trends India',
      'foodservice equipment case studies India',
    ]),
  },
];

export function getSeoForPath(pathname) {
  for (const config of seoRoutes) {
    for (const path of config.paths) {
      if (matchPath({ path, end: true }, pathname)) {
        return config;
      }
    }
  }

  return defaultSeo;
}

export { defaultSeo };
